import { Injectable } from "@angular/core";

@Injectable()
export class DatetimeTimerProvider {
  startTime: Date;
  endTime: Date;
  interval: number;
  elapsedSecond: number;
  isActive: boolean;

  constructor() {
    this.clear();
  }

  setStartTime(startTime: Date): void {
    this.startTime = startTime;
  }

  setEndTime(endTime: Date): void {
    this.endTime = endTime;
  }

  setStartToEndSecond(): void {
    if (this.startTime && this.endTime) {
      this.elapsedSecond = this.calcElapsedSecond(this.startTime, this.endTime);
    }
  }

  getElapsedSecond(): number {
    return this.elapsedSecond;
  }

  getIsActive(): boolean {
    return this.isActive;
  }

  start(): void {
    this.isActive = true;
    this.interval = window.setInterval(() => {
      this.updateElapsedSecond();
    }, 1000);
  }

  stop(): void {
    clearInterval(this.interval);
    this.isActive = false;
    this.setStartToEndSecond();
  }

  clear(): void {
    this.stop();
    this.isActive = false;
    this.elapsedSecond = 0;
    this.startTime = undefined;
    this.endTime = undefined;
  }

  private updateElapsedSecond(): void {
    const now = new Date();
    this.elapsedSecond = this.calcElapsedSecond(this.startTime, now);
  }

  private calcElapsedSecond(dateFrom: Date, dateTo): number {
    return Math.round((dateTo.getTime() - dateFrom.getTime()) / 1000);
  }
}



// WEBPACK FOOTER //
// ./src/providers/datetime-timer/datetime-timer.ts